const Button = (props) => {
  const { onClick, children } = props;
  return (
    <button className="linkCopyButtonStyle" onClick={onClick}>
      {children}
    </button>
  );
};
export default Button;
